/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('readerContextMenu', function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/context-menu/context-menu.view.html',
            controller: ["$scope", "DocumentService", "DocumentModel", "$interval", "$cookieStore", function ($scope, DocumentService, DocumentModel, $interval, $cookieStore) {
                var scope = $scope;
                var cookieStore = $cookieStore;
                var intervalHandler;
                var currentTheme;

                scope.fontSizeUpdate = function(newFontScale) {
                    var styleElement;

                    if(!angular.element('#fontSizeModifier').length){
                        styleElement = document.createElement('style');
                        styleElement.type = 'text/css';
                        document.getElementsByTagName('head')[0].appendChild(styleElement);
                        styleElement.setAttribute('id','fontSizeModifier');
                        styleElement = angular.element(styleElement);
                    } else {
                        styleElement = angular.element('#fontSizeModifier');
                    }
                    styleElement.html('content-wrapper * { font-size: ' + newFontScale + 'px!important;}');
                    scope.scroll.refresh();
                    DocumentService.recalculateDocumentHeight();
                    scope.fontSize = newFontScale;
                    cookieStore.put('viewportFontSize', scope.fontSize);
                };

                scope.colorThemeUpdate = function(newColorTheme) {
                    var themeList = ['color-theme-black','color-theme-white','color-theme-gray','color-theme-brown'];
                    var bodyElement = angular.element('body');

                    currentTheme = newColorTheme;

                    _.each(themeList, function(el, i){
                        bodyElement.removeClass(el);
                        bodyElement.removeClass('starwars');
                    });

                    scope.contextMenu.color = newColorTheme;
                    cookieStore.put('viewportColor', scope.contextMenu.color.replace('starwars',''));
                    bodyElement.addClass('color-theme-' + newColorTheme);
                    //if(bodyElement.hasClass('starwars')){
                    //    intervalHandler = $interval(function(){
                    //        scope.scroll.scrollBy(0, -1, 50);
                    //    }, 51);
                    //    scope.fontSizeUpdate('19');
                    //} else if(!!intervalHandler){
                    //    $interval.cancel(intervalHandler);
                    //    intervalHandler = null;
                    //}
                    scope.notesPopover.close();
                    scope.contextMenu.isOpen = false;
                };

                scope.getCurrentTheme = function(){
                    return currentTheme;
                };

                //object from shared parent scope for this context - contextMenu {left, top, isOpen << bdfault, never touch these within this controller}


                scope.contextMenu.fontList = [
                    { name: 'Arial', selected: false, className: 'viewport-font-arial' },
                    { name: 'Times New Roman', selected: false, className: 'viewport-font-times' },
                    { name: 'Verdana', selected: false, className: 'viewport-font-verdana' },
                    { name: 'Calibri', selected: false, className: 'viewport-font-calibri' },
                    { name: 'Roboto', selected: false, className: 'viewport-font-roboto' },
                    { name: 'Georgia', selected: false, className: 'viewport-font-georgia' }
                ];


                scope.changeContextMode = function(newMode, e){
                    scope.contextMenu.mode = newMode;
                    e && e.stopPropagation();
                    e && e.preventDefault();
                };

                scope.updateSelectedFont = function(newFontName){
                    var bodyElement = angular.element('body');

                    _.each(scope.contextMenu.fontList, function(el,i){
                        el.selected = false;
                        bodyElement.removeClass(el.className);
                    });

                    _.filter(scope.contextMenu.fontList, function(el,i){
                        if (el.name === newFontName) {
                            bodyElement.addClass(el.className);
                            el.selected = true;
                            return true;
                        }
                        return false;
                    });

                    scope.contextMenu.selectedFont = newFontName;
                    cookieStore.put('viewportFontName', newFontName);
                    scope.changeContextMode('settings');
                    scope.scroll.refresh();
                    DocumentService.recalculateDocumentHeight();
                    scope.notesPopover.close();
                    scope.contextMenu.isOpen = false;
                };
                scope.changeContextMode('settings');
                scope.updateSelectedFont(cookieStore.get('viewportFontName') || 'Georgia');

                scope.launchFullScreen = (function(){
                    var fullScreenEnabled;
                    var fullScreenEnable = function() {
                        var element = document.documentElement;

                        if (element.requestFullscreen) {
                            element.requestFullscreen();
                        } else if (element.webkitRequestFullscreen) {
                            element.webkitRequestFullscreen();
                        } else if (element.msRequestFullscreen) {
                            element.msRequestFullscreen();
                        } else if (element.webkitRequestFullScreen) {
                            element.webkitRequestFullScreen();
                        } else if (element.mozRequestFullScreen) {
                            element.mozRequestFullScreen();
                        }
                        fullScreenEnabled = true;
                    };
                    var fullScreenDisable = function() {
                        if(document.requestFullscreen) {
                            document.requestFullscreen();
                        } else if(document.msExitFullscreen ) {
                            document.msExitFullscreen();
                        } else if(document.webkitCancelFullScreen ) {
                            document.webkitCancelFullScreen();
                        } else if(document.mozCancelFullScreen) {
                            document.mozCancelFullScreen();
                        }
                        fullScreenEnabled = false;
                    };

                    return function() {
                        !!fullScreenEnabled ? fullScreenDisable() : fullScreenEnable();
                        scope.notesPopover.close();
                        scope.contextMenu.isOpen = false;
                    };
                })();

                DocumentService.subscribe.onScrollCreated(function(){
                    scope.contextMenu.color = cookieStore.get('viewportColor') || 'white';
                    scope.colorThemeUpdate(scope.contextMenu.color);
                    scope.fontSize = cookieStore.get('viewportFontSize') || 21;


                    angular.element('readercontextmenu .slider').slider({
                        min: 15, //will be applied as to 1.0em
                        max: 32, //will be applied as to 5.0em
                        step: 1,
                        value: scope.fontSize,
                        change: function(e, ui){
                            scope.fontSizeUpdate(ui.value);
                        }
                    });





                    scope.fontSizeUpdate(scope.fontSize);

                });
                console.log('%c Press Shift + 6 for comfortable reading!', 'background: #222; color: #bada55');
            }]

        };


    });